var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-page"},[_c('img',{staticClass:"activity-image",attrs:{"src":_vm.activity,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }